import { assessmentsHandlers } from './assessments';
import { authHandlers } from './auth';
import { batchSelectionHandlers } from './batch-selection';
import { bhanzuBuddyHandlers } from './bhanzu-buddy';
import { calendarHandlers } from './calendar';
import { enrollmentsHandlers } from './enrollments';
import { invoiceLinkHandlers } from './invoice-link';
import { moduleReportsHandlers } from './module-reports';
import { modulesHandlers } from './modules';
import { profilesHandlers } from './profiles';
import { sessionsHandlers } from './sessions';
import { userHandlers } from './user';
import { waitlistHandlers } from './waitlist-status';

export const handlers = [
  ...authHandlers,
  ...bhanzuBuddyHandlers,
  ...userHandlers,
  ...sessionsHandlers,
  ...modulesHandlers,
  ...calendarHandlers,
  ...assessmentsHandlers,
  ...moduleReportsHandlers,
  ...waitlistHandlers,
  ...batchSelectionHandlers,
  ...invoiceLinkHandlers,
  ...enrollmentsHandlers,
  ...profilesHandlers,
];
